window.OBNonCandidatesDocsModal = function ($scope, Upload, hUser, userPermissions, userServices, authorityToRecruitDataService, onBoardingService) {
    var self = this;

    var MODAL_SELECTOR = "#ob_ncandidates_docs_modal";
    var initialized = false;
    var deletedDocuments = [];

    self.nCandidatesDocsForm = new NCandidatesDocsForm($scope, Upload, userPermissions, userServices, authorityToRecruitDataService, onBoardingService);
    self.nCandidatesDocsForm.onDeleteDocument(function(document){
        deletedDocuments.push(document);
    });

    var events = {
       "documents_uploaded": [],
       "documents_deleted": []
    };

    self.onDocumentsUploaded = function(handler) {
        events["documents_uploaded"].push(handler);
    };

    self.onDocumentsDeleted = function(handler) {
        events["documents_deleted"].push(handler);
    };

    var trigger = function(eventName, param1, param2, param3, param4) {
        events[eventName].forEach(function(handler){
            handler(param1, param2, param3, param4);
        });
    };

    self.show = function (OBIdObj) {
        self.nCandidatesDocsForm.load(OBIdObj);
        self.isBrandArchived = OBIdObj.isBrandArchived;
        self.action = OBIdObj.action;

        $(MODAL_SELECTOR).modal("show");

        if (!initialized) {
            initialized = true;
            $(MODAL_SELECTOR).on('hidden.bs.modal', function () {
                if(deletedDocuments.length){
                    trigger("documents_deleted", {
                        deletedDocuments: deletedDocuments,
                        brand_id: OBIdObj.brand_id
                    });
                }
                self.destroy();
            });
        }
    };

    self.hide = function () {
        $(MODAL_SELECTOR).modal("hide");
    };
    self.isThereSelectedFiles = function () {
        for (let i in self.nCandidatesDocsForm.data.newDocs) {
            if (self.nCandidatesDocsForm.data.newDocs[i].selectedFile) {
                return true;
            }
        }
        return false;
    };

    self.destroy = function () {

        if (self.nCandidatesDocsForm) {
            self.nCandidatesDocsForm.destroy();
        }

        $scope.$digest();
    };

    self.saveNonCandidateDocs = function(){
        var submitBtn = $(MODAL_SELECTOR).find('.save-btn');

        submitBtn.button('loading');
        self.uploadingInProgress = true;
        self.nCandidatesDocsForm.save().then(function(result){
            trigger("documents_uploaded", result);
            //hide the modal
            self.hide();
            self.uploadingInProgress = false;
            submitBtn.button('reset');
        },function(res){
            //reset save button
            self.uploadingInProgress = false;
            submitBtn.button('reset');
        });
    }

}
